import { takeEvery, call, put } from 'redux-saga/effects';
import actionTypes from 'redux/actionTypes';
import {
	loadTemplateOnEdit,
	getTempatesSuccess,
	getTempatesFailure,
	getCustomAttributeFailure,
	getCustomAttributeSuccess,
	loadPreviewOnEdit
} from './Template.actions';

import APIURLPATH from 'constants/apiconstants';
import { getData } from 'service/getData.service';
import {
	getPreviewSuccess,
	getPreviewFailure,
	setLinkItemActivity
} from 'components/Preview/Preview.actions';
import { postData } from 'service/postData.service';
import { NO_PERSONA, PERSONA } from 'constants/constant';

export function* getPreviewSaga(request) {
	const {
		payload: {
			editData: { templateId }
		}
	} = request;

	const URL = `${APIURLPATH.PREVIEW}?templateId=${templateId}`;
	try {
		const previewRes = yield call(postData, URL, request.payload);

		if (previewRes?.statusCode >= 400) {
			throw new Error(previewRes?.statusCode);
		}

		yield put(getPreviewSuccess(previewRes?.json));
	} catch (error) {
		yield put(getPreviewFailure(505));
	}
}

export function* getTempatesSaga(request) {
	const { payload } = request;
	const previewRequest = {
		requestBody: payload?.payload?.requestBody,
		companyName: payload?.payload?.companyName,
		editData: payload?.payload?.editData
	};
	try {
		const {
			payload: { payload }
		} = request;
		const { selectedPersona = NO_PERSONA } = payload;

		const tempatesRes = yield call(
			getData,
			`${APIURLPATH.VIEW_TYPE}${selectedPersona}`,
			request.payload
		);

		if (tempatesRes?.statusCode >= 400) {
			throw new Error(tempatesRes?.statusCode);
		}
		yield put(getTempatesSuccess(tempatesRes?.json));
		yield put(loadPreviewOnEdit(previewRequest));
	} catch (error) {
		yield put(getTempatesFailure(505));
		yield put(loadPreviewOnEdit(previewRequest));
	}
}

export function* getStartLoadPreviewSaga(request) {
	/**
	 * Loading of Preview page start by hitting get attribute list
	 */
	try {
		const {
			payload: { selectedPersona = PERSONA.SUPPLIER }
		} = request;

		let tempatesRes = {
			json: [],
			statusCode: 200
		};

		if (['SUPPLIER', 'CATMAN'].includes(selectedPersona)) {
			tempatesRes = yield call(
				getData,
				`${APIURLPATH.CUSTOM_ATTRIBUTES_TYPE}${selectedPersona}`,
				request.payload
			);
		}

		if (tempatesRes?.statusCode >= 400) {
			throw new Error(tempatesRes?.statusCode);
		}
		yield put(getCustomAttributeSuccess(tempatesRes?.json));
		yield put(loadTemplateOnEdit(request));
		const linkItemActivity = request?.payload?.editData?.linkItemActivity;
		yield put(setLinkItemActivity(linkItemActivity ? linkItemActivity : ''));
	} catch (error) {
		yield put(getCustomAttributeFailure(505));
		yield put(loadTemplateOnEdit(request));
	}
}

export function* LoadPreviewPageSagaWatcher() {
	yield takeEvery(actionTypes.LOAD_PREVIEW_PAGE, getStartLoadPreviewSaga);
	yield takeEvery(actionTypes.LOAD_TEMPLATE_ON_EDIT, getTempatesSaga);
	yield takeEvery(actionTypes.LOAD_PREVIEW_ON_EDIT, getPreviewSaga);
}
